// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"48":"24e7875b","353":"81aa2e35","573":"3dca57b7","979":"ad9aad21"}[chunkId] + ".css";
};